// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  api_base: 'https://flc-frontend.fks.be/api',
  //api_base: 'http://localhost:8080',
  main_color: '#173782',
  draw_color: '#173782',

  default_center: [ 1000430.97, 6051589.24 ],
  maxExtent: [989397.4, 6032665.79, 1011468.12, 6070527.52],
  default_zoom: 3,
  osm_url: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png',

  localstorage_prefix:'flc:',
  section_tunnel_tiles_url: '/v1/tunnelsections/vectortiles/{z}/{x}/{y}.mvt',
  section_tunnel_tile_url: '/v1/tunnelsections/vectortile/:id/{z}/{x}/{y}.mvt',
  section_stress_tiles_url: '/v1/tunnelstressarea/vectortiles/{z}/{x}/{y}.mvt',
  section_stress_tile_url: '/v1/tunnelstressarea/vectortile/:id/{z}/{x}/{y}.mvt',
  section_stress_group_tiles_url: '/v1/stressareagroup/vectortiles/:grouptype/{z}/{x}/{y}.mvt',
  section_stress_group_tile_url: '/v1/stressareagroup/vectortile/:id/:grouptype/{z}/{x}/{y}.mvt',
  raster_tile_url: '/v1/raster/rastertile/:id/{z}/{x}/{y}.png',
  raster_tiles_url: '/v1/raster/rastertiles/{z}/{x}/{y}.png',
  default_stress_group: 'GROUP_2x1',

  version: 'flc-23/04/2024'

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
